import React from 'react';
import {useGetStoresQuery} from '@graphql/generated/graphql';
import {useGeolocation} from 'context/geolocationContext';
import {usePersistentStore} from 'stores';
import {Spinner, StoreList} from '..';

interface ISearchStoresProps {
  searchString?: string;
  categoryId?: string;
}

const SearchStores: React.FC<ISearchStoresProps> = ({searchString, categoryId}) => {
  const {latitude, longitude} = useGeolocation();
  const deliveryOption = usePersistentStore(s => s.deliveryOption);

  const {data} = useGetStoresQuery({
    variables: {
      deliveryOption,
      searchString,
      categoryId,
      latitude,
      longitude,
    },
    fetchPolicy: 'cache-and-network',
    skip: ![latitude, longitude].filter(Boolean).length,
  });

  if (!data) {
    return <Spinner />;
  }

  return <StoreList stores={data.stores} showDistance />;
};

export default SearchStores;
